import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { User, AuthContextType } from "../utils/common";
import { useAuth } from "../context/AuthContext";
import { SHARED_STYLES } from "../utils/constants";

const LoginPromptBanner: React.FC = () => {
  const navigate = useNavigate();
  const { openAuthModal } = useAuth();

  // ✅ Added state (no existing code removed)
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "relative", // ✅ Added
        background: "#E8F4FD",
        ...SHARED_STYLES.bannerContainer,
      }}
    >
      {/* ✅ Close Button Added */}
      <span
        className="banner-close"
        onClick={() => setVisible(false)}
        style={{
          background: "#E8F4FD",
          paddingRight: "40px", // prevent overlap
          ...SHARED_STYLES.bannerCloseButton,
        }}
      >
        ×
      </span>

      <div>
        <strong>Unlock full SocialFlow benefits</strong>
        <div style={{ fontSize: "13px", color: "#555" }}>
          Login to manage apps, analytics, and personalized features.
        </div>
      </div>

      <button
        style={{
          ...SHARED_STYLES.bannerButton,
        }}
        onClick={openAuthModal}
      >
        Login Now
      </button>
    </div>
  );
};

export default LoginPromptBanner;
